module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.ab04959e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-bold-webfont.ttf
// module id = 502
// module chunks = 0